import styled from "styled-components";
import { CheckboxWrapper } from "../form/styles/checkbox";

export const TermsCompStyle = styled.div`
  text-align: left;
`;

export const TermsCheckboxWrapper = styled(CheckboxWrapper)`
    width: 100%;
`;